export const ru = {
    serverErrorMessage:
        "Ошибка при обращении к серверу. Попробуйте повторить действие через некоторое время...",
}
